module.exports = __webpack_public_path__ + "img/img-8.532eac63.png";